export default {
  Detail: {
    Title: 'Khảo sát mức độ hài lòng',
    SendFeedback: 'Gửi phản hồi',
    Later: 'Để sau',
    RatingColorRed: 'red',
    RatingColorBlue: 'blue',
    RatingColorGreen: 'green',
    ContinueToUse: 'Tiếp tục sử dụng phần mềm',
    TitleRating: 'Bạn có hài lòng khi sử dụng MISA Bamboo Online không?',
    Unsatisfied: 'Chưa hài lòng',
    Satisfied: 'Hài lòng',
    Pleased: 'Rất hài lòng',
    Reason: 'Xin hãy cho biết lý do bạn chưa hài lòng với sản phẩm?',
    ReasonOne: 'Công tác tập huấn triển khai chưa tốt',
    ReasonTwo: 'Sản phẩm hay bị lỗi',
    ReasonThree: 'Sản phẩm không đáp ứng nhu cầu',
    ReasonFour: 'Bảo mật phần mềm kém',
    ReasonFire: 'Thao tác sử dụng không thuận tiện',
    ReasonSix: 'Tốc độ xử lý chậm',
    ReasonSeven: 'Dịch vụ tư vấn KH kém',
    ReasonEight: 'Giá thành cao',
    RangeLevelOne: 'Chúng tôi cần làm gì để mang lại trải nghiệm tốt hơn cho bạn? Lý do khác:',
    RangeLevelTwo: ' Chúng tôi cần làm gì để mang lại thêm nhiều tiện ích hơn nữa cho bạn?',
    RangeLevelThree: 'Thật tuyệt! Có điều gì chúng tôi cần làm tốt hơn nữa không?',
    ConfirmReason: 'Bạn cần chọn lý do chưa hài lòng trước khi gửi kết quả đánh giá',
  },
};
